import type TabStore from "./schema/TabStore";
import { type default as TabViewState, type PrimaryReadingPaneTabViewState, TabType, type TabState } from "./schema/TabViewState";
import { createStore } from "owa-satcheljs";

const primaryTabInitialState: PrimaryReadingPaneTabViewState = {
    id: "primaryTab",
    type: TabType.Primary,
    state: 2,
    blink: false,
    sxsId: "primaryTab",
    data: null,
};

const tabStoreData: TabStore = {
    tabs: [primaryTabInitialState],
    tabBarWidth: 0,
    isTabBarAvailable: false,
};

const getStore: () => TabStore = createStore<TabStore>("tab", tabStoreData);
export { getStore };
export default getStore;

// Export the reference from the store (http://aka.ms/mobx4)
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getStore called at module scope is not allowed. This may cause unwanted side effects. */
export const primaryTab: TabViewState = getStore().tabs[0];
